import { Import } from '..';

type ImportTemplateProps = {} | { templateName: string } | { onRender: () => React.JSX.Element };

export function ImportTemplate(props: ImportTemplateProps) {
    const defaultDownloadTemplateRender = () => {
        const templateName = 'templateName' in props ? props.templateName : 'upload-template-example';

        return (
            <p className="ant-upload-hint" key="download-template-section">
                Download an empty example template file &nbsp;
                <Import.DownloadTemplateButton key="download-template-button" type="default" templateName={templateName} />
            </p>
        );
    };

    const _onRender = 'onRender' in props ? props.onRender : defaultDownloadTemplateRender;

    return <div style={{ margin: '25px 0' }}>{_onRender()}</div>;
}
